import moment from 'moment';
import range from 'lodash.range';
import get from 'lodash.get';
import { combineReducers } from 'redux';
import { delay } from 'redux-saga';
import { call, put, select, takeLatest, takeEvery } from 'redux-saga/effects';
import dedent from 'dedent';
import {
    SAVE_LOG,
    REMOVE_LOG,
    DELETE_LOG,
    DELETE_LOG_SUCCESS,
    DELETE_LOG_FAILURE,
} from './log';
import { SAVE_PREFERENCES_SUCCESS } from './preferences';
import prepareBody from '../utils/prepareBody';
import mergeArray from '../utils/mergeArray';
// import shareContent from '../utils/shareContent';
import { selectPlanId, selectRunnerId } from './auth';
import stravaStreamHillSearch from '../utils/stravaStreamHillSearch';
import matchHills from '../utils/matchHills';

export const FETCH_WORKOUT = 'workouts/FETCH_WORKOUT';
export const FETCH_WORKOUT_SUCCESS = 'workouts/FETCH_WORKOUT_SUCCESS';
export const FETCH_WORKOUT_FAILURE = 'workouts/FETCH_WORKOUT_FAILURE';
export const FETCH_ALL_WORKOUTS = 'workouts/FETCH_ALL_WORKOUTS';
export const FETCH_ALL_WORKOUTS_SUCCESS = 'workouts/FETCH_ALL_WORKOUTS_SUCCESS';
export const FETCH_ALL_WORKOUTS_FAILURE = 'workouts/FETCH_ALL_WORKOUTS_FAILURE';
export const CLEAR_ALL_WORKOUTS = 'workouts/CLEAR_ALL_WORKOUTS';
export const FETCH_FULL_DATA = 'workouts/FETCH_FULL_DATA';
export const FETCH_FULL_DATA_SUCCESS = 'workouts/FETCH_FULL_DATA_SUCCESS';
export const FETCH_FULL_DATA_FAILURE = 'workouts/FETCH_FULL_DATA_FAILURE';
export const SEND_WEEK_EMAIL = 'workouts/SEND_WEEK_EMAIL';
export const SEND_WEEK_EMAIL_SUCCESS = 'workouts/SEND_WEEK_EMAIL_SUCCESS';
export const SEND_WEEK_EMAIL_FAILURE = 'workouts/SEND_WEEK_EMAIL_FAILURE';
export const FETCH_SHARE = 'workouts/FETCH_SHARE';
export const FETCH_SHARE_SUCCESS = 'workouts/FETCH_SHARE_SUCCESS';
export const FETCH_SHARE_FAILURE = 'workouts/FETCH_SHARE_FAILURE';
export const FETCH_STRAVA_STREAM = 'workouts/FETCH_STRAVA_STREAM';
export const FETCH_STRAVA_STREAM_SUCCESS = 'workouts/FETCH_STRAVA_STREAM_SUCCESS';
export const FETCH_STRAVA_STREAM_FAILURE = 'workouts/FETCH_STRAVA_STREAM_FAILURE';
export const GET_HILL_MATCHES = 'workouts/GET_HILL_MATCHES';
export const GET_HILL_MATCHES_SUCCESS = 'workouts/GET_HILL_MATCHES_SUCCESS';
export const GET_HILL_MATCHES_FAILURE = 'workouts/GET_HILL_MATCHES_FAILURE';

export const items = (state = {}, action) => {
    switch (action.type) {
        case SAVE_LOG:
            return Object.keys(state).reduce((obj, day) => {
                const item = state[day];
                const date = moment(action.log.date).startOf('day');
                obj[day] = { // eslint-disable-line
                    ...item,
                };
                if (moment(item.date).startOf('day').isSame(date)) {
                    obj[day].log = { // eslint-disable-line
                        ...action.log,
                    };
                    obj[day].completed = true; // eslint-disable-line
                }
                return obj;
            }, {});
        case DELETE_LOG_SUCCESS: {
            const day = action.log.training_day;
            return {
                ...state,
                [day]: {
                    ...state[day],
                    completed: false,
                },
            };
        }
        case REMOVE_LOG:
            return Object.keys(state).reduce((obj, day) => {
                const item = state[day];
                const workoutId = action.workout;
                obj[day] = { // eslint-disable-line
                    ...item,
                };
                if (item.id === workoutId) {
                    obj[day].log = {}; // eslint-disable-line
                }
                return obj;
            }, {});
        case FETCH_WORKOUT_SUCCESS:
            return {
                ...state,
                [action.day]: action.result,
            };
        case FETCH_ALL_WORKOUTS_SUCCESS: {
            const workouts = action.result;
            return Object.keys(workouts).reduce((acc, day) => {
                acc[day] = { // eslint-disable-line
                    ...(state[day] || {}),
                    ...workouts[day],
                    log: {
                        ...get(state[day], 'log', {}),
                        ...workouts[day].log,
                    },
                    week: {
                        ...get(state[day], 'week', {}),
                    },
                };
                return acc;
            }, {});
        }
        case FETCH_STRAVA_STREAM:
            return {
                ...state,
                [action.day]: {
                    ...state[action.day],
                    strava: {
                        ...state[action.day].strava,
                        loading: true,
                    },
                },
            };
        case FETCH_STRAVA_STREAM_SUCCESS: {
            const result = action.result;
            const prevStrava = state[action.day].strava ? state[action.day].strava : {};
            const stravaAdd = Object.keys(result).reduce((obj, key) => {
                const newKey = `${key}Stream`;
                const data = result[key].data;
                obj[newKey] = data; // eslint-disable-line
                return obj;
            }, {});
            return {
                ...state,
                [action.day]: {
                    ...state[action.day],
                    strava: {
                        ...prevStrava,
                        ...stravaAdd,
                        loading: false,
                    },
                },
            };
        }
        case GET_HILL_MATCHES: {
            return {
                ...state,
                [action.day]: {
                    ...state[action.day],
                    hills: {
                        ...action.runHills,
                    },
                },
            };
        }
        case SAVE_PREFERENCES_SUCCESS:
            return action.page === 'manage' ? {} : state;
        case CLEAR_ALL_WORKOUTS:
            return {};
        default:
            return state;
    }
};

export const error = (state = null, action) => {
    switch (action.type) {
        case FETCH_ALL_WORKOUTS:
        case FETCH_WORKOUT:
        case FETCH_ALL_WORKOUTS_SUCCESS:
        case FETCH_WORKOUT_SUCCESS:
            return null;
        case FETCH_ALL_WORKOUTS_FAILURE:
        case FETCH_WORKOUT_FAILURE:
            return action.error;
        default:
            return state;
    }
};

export const loading = (state = null, action) => {
    switch (action.type) {
        case FETCH_ALL_WORKOUTS:
        case FETCH_WORKOUT:
        case DELETE_LOG:
            return true;
        case FETCH_ALL_WORKOUTS_SUCCESS:
        case FETCH_WORKOUT_SUCCESS:
        case FETCH_ALL_WORKOUTS_FAILURE:
        case FETCH_WORKOUT_FAILURE:
        case DELETE_LOG_SUCCESS:
        case DELETE_LOG_FAILURE:
            return false;
        default:
            return state;
    }
};

export const workoutLoading = (state = null, action) => {
    switch (action.type) {
        case FETCH_WORKOUT:
            return true;
        case FETCH_WORKOUT_SUCCESS:
        case FETCH_WORKOUT_FAILURE:
            return false;
        default:
            return state;
    }
};

export const sendingEmail = (state = false, action) => {
    switch (action.type) {
        case SEND_WEEK_EMAIL:
            return true;
        case SEND_WEEK_EMAIL_SUCCESS:
        case SEND_WEEK_EMAIL_FAILURE:
            return false;
        default:
            return state;
    }
};

export const full = (state = {}, action) => {
    switch (action.type) {
        case FETCH_FULL_DATA_SUCCESS:
            return {
                low: action.result['Prescribed Week LOW'],
                high: action.result['Prescribed Week HIGH'],
                completed: action.result['Completed Week'],
                long: action.result['Long Run'],
                circles: [1, 2, 3].map(i => ({
                    label: action.result[`Data Circle ${i} Label`],
                    value: action.result[`Data Circle ${i} Value`],
                })),

            };
        default:
            return state;
    }
};

export const socialShareUrls = (state = {}, action) => {
    switch (action.type) {
        case FETCH_SHARE_SUCCESS:
            return {
                ...state,
                [action.day]: action.result[0].share_link,
            };
        case FETCH_SHARE_FAILURE:
            return state;
        default:
            return state;
    }
};

export function* refreshFullPlan({ result }) {
    if (result.refresh === 1) {
        yield call(delay, 2000);
        yield put(clearAllWorkouts());
        yield put(fetchWorkoutsData());
        return yield put(fetchWorkouts());
    }
    return null;
}

export function* afterWorkoutStrava({ weekView, result, fromFullPlan }) {
    if (result.strava.id !== null && !weekView && !fromFullPlan && result.completed === true) {
        return yield put(fetchStravaStream(result.day, result.strava.id));
    }
    return null;
}

export function* watchWorkoutRefresh() {
    yield takeLatest(FETCH_WORKOUT_SUCCESS, refreshFullPlan);
}

export function* watchWorkoutFetch() {
    yield takeEvery(FETCH_WORKOUT_SUCCESS, afterWorkoutStrava);
}

export function* watchStravaSuccess() {
    yield takeEvery(FETCH_STRAVA_STREAM_SUCCESS, executeHillMatcher);
}

export function* rootSaga() {
    yield [
        watchWorkoutRefresh(),
        watchWorkoutFetch(),
        watchStravaSuccess(),
    ];
}

function* executeHillMatcher({ day }) {
    const strava = yield select(state => (state.workouts.items[day].strava));
    const gradesStream = strava.grade_smoothStream;
    const distanceStream = strava.distanceStream;
    const altitudeStream = strava.altitudeStream;
    const courseHills = yield select(state => (state.race.info.courseHills));
    if (courseHills) {
        const args = {
            gradesStream,
            distanceStream,
            altitudeStream,
            courseHills,
        };

        const runHills = yield call(computeHillMatches, args);

        return yield put(getHillMatches(day, runHills));
    }
    return null;
}

const computeHillMatches = ({ gradesStream, distanceStream, altitudeStream, courseHills }) => {
    const hills = stravaStreamHillSearch(gradesStream, distanceStream, altitudeStream);
    for (let i = 0; i < Object.keys(hills).length; i++) { // eslint-disable-line
        const match = matchHills(courseHills, hills[i]);
        if (match && match.score) {
            hills[i] = {
                ...hills[i],
                match,
            };
        }
    }
    return hills;
};

export default combineReducers({
    items,
    loading,
    sendingEmail,
    error,
    full,
    workoutLoading,
    socialShareUrls,
});

export const selectWorkout = (state, day = 1) => state.items[day];

// figure out current(today) day if not provided
// using raceDate and totalWorkouts
export const getWorkoutDay = ({ raceDate, totalWorkouts, day }) => {
    if (day) {
        const currentDay = parseInt(day, 10);
        if (currentDay <= totalWorkouts) {
            return Math.max(0, currentDay);
        }
    }
    const race = moment(raceDate).startOf('day');
    const now = moment().startOf('day');
    const diff = race.diff(now, 'day');
    const today = totalWorkouts - diff;
    if (today > totalWorkouts) {
        return totalWorkouts;
    }

    return Math.max(0, today);
};

// get workouts
export const filterWorkouts = (list, treningDays) =>
    treningDays.filter(i => !!list[i]).map(i => list[i]);

export const getWorkoutWeek = ({ raceDate, totalWorkouts, week }) => {
    if (week) {
        return Math.max(1, parseInt(week, 10));
    }

    const day = Math.max(1, getWorkoutDay({ raceDate, totalWorkouts }));

    return getWeekFromDay(day);
};

export const getWeekFromDay = day => Math.max(1, Math.ceil(day / 7));

export const getWeekWorkouts = (week) => {
    const start = ((week - 1) * 7) + 1;
    const end = start + 7;
    return range(start, end);
};

export const workoutDate = ({ raceDate, totalWorkouts, day }) =>
    moment(raceDate).subtract(totalWorkouts - day, 'days').toISOString(true);

export const workoutDayFromDate = ({ raceDate, totalWorkouts, date }) => {
    const endDate = moment(raceDate).startOf('day');
    const startDate = moment(date).startOf('day');
    const diff = endDate.diff(startDate, 'days');

    if (diff < 0) {
        return 356;
    }

    if (diff > totalWorkouts) {
        return 0;
    }

    return totalWorkouts - diff;
};

export const isRace = (workout) => {
    let type = workout.type;
    if (workout.completed && workout.log) {
        type = workout.log.log_runtype;
    }
    return type === 'Race';
};

export const fetchStravaStream = (day = 1, actId) => ({
    types: [FETCH_STRAVA_STREAM, FETCH_STRAVA_STREAM_SUCCESS, FETCH_STRAVA_STREAM_FAILURE],
    day,
    actId,
    promise: ({ getState }) => {
        const state = getState();
        const { preferences } = state;
        const stoken = preferences.values.Strava;
        const types = 'altitude,latlng,grade_smooth';
        const fetchUrl = `https://www.strava.com/api/v3/activities/${actId}/streams?keys=${types}&key_by_type=true`;
        return fetch(fetchUrl, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${stoken}`,
            },
        }).then(res => res.json());
    },
});


export const fetchWorkout = (day = 1, weekView = 0, fromFullPlan = false) => ({
    types: [FETCH_WORKOUT, FETCH_WORKOUT_SUCCESS, FETCH_WORKOUT_FAILURE],
    day,
    promise: ({ getState }) => {
        const state = getState();
        const { race } = state;
        const raceDate = race.info.race_date;
        const totalWorkouts = race.info.plan_week * 7;
        const goalRaceName = race.info.race_name;
        return fetch(`${process.env.RTAPI_URL}/API_day.php`, {
            method: 'POST',
            body: prepareBody({
                plan_id: selectPlanId(state),
                runner_id: selectRunnerId(getState()),
                training_day: day,
                week_call: weekView,
            }),
        }).then(res => res.json())
        .then(mergeArray)
        .then(workout => transformWorkout({
            workout,
            raceDate,
            totalWorkouts,
            goalRaceName,
            day,
        }));
    },
    weekView,
    fromFullPlan,
});

export const fetchWorkouts = () => ({
    types: [FETCH_ALL_WORKOUTS, FETCH_ALL_WORKOUTS_SUCCESS, FETCH_ALL_WORKOUTS_FAILURE],
    promise: ({ getState }) => {
        const state = getState();
        const { race } = state;
        const raceDate = race.info.race_date;
        const totalWorkouts = race.info.plan_week * 7;
        const goalRaceName = race.info.race_name;
        return fetch(`${process.env.RTAPI_URL}/API_fullplan.php`, {
            method: 'POST',
            body: prepareBody({
                plan_id: selectPlanId(state),
                runner_id: selectRunnerId(getState()),
            }),
        })
        .then(res => res.json())
        .then(result => transformFullWorkouts({
            result,
            raceDate,
            totalWorkouts,
            goalRaceName,
        }));
    },
});

export const fetchWorkoutsData = () => ({
    types: [FETCH_FULL_DATA, FETCH_FULL_DATA_SUCCESS, FETCH_FULL_DATA_FAILURE],
    promise: ({ getState }) => {
        const state = getState();
        const race = state.race.info;
        const totalWorkouts = race.plan_week * 7;
        const raceDate = race.race_date;
        return fetch(`${process.env.RTAPI_URL}/API_data_fullplan.php`, {
            method: 'POST',
            body: prepareBody({
                plan_id: selectPlanId(state),
                runner_id: selectRunnerId(getState()),
                training_day: getWorkoutDay({ totalWorkouts, raceDate }),
            }),
        }).then(res => res.json());
    },
});

export const sendWorkoutEmail = (week = 0, day = 0) => ({
    types: [SEND_WEEK_EMAIL, SEND_WEEK_EMAIL_SUCCESS, SEND_WEEK_EMAIL_FAILURE],
    promise: ({ getState }) => fetch(`${process.env.RTAPI_URL}/API_send_week.php`, {
        method: 'POST',
        body: prepareBody({
            plan_id: selectPlanId(getState()),
            runner_id: selectRunnerId(getState()),
            training_week: week,
            training_day: day,
        }),
    }).then(res => res.json()),
});

export const shareWorkout = day => ({
    types: [FETCH_SHARE, FETCH_SHARE_SUCCESS, FETCH_SHARE_FAILURE],
    promise: ({ getState }) => fetch(`${process.env.RTAPI_URL}/API_share.php`, {
        method: 'POST',
        body: prepareBody({
            plan_id: selectPlanId(getState()),
            runner_id: selectRunnerId(getState()),
            training_day: day,
        }),
    })
    .then(res => res.json()),
    day,
});

export const getHillMatches = (day, runHills) => ({
    type: GET_HILL_MATCHES,
    day,
    runHills,
});

export const fetchWeek = week => ({ dispatch }) =>
    week.map(day =>
        dispatch(fetchWorkout(day, 1)),
    );

// MAP workouts
const getTitle = (type, volume, units) => {
    switch (type) {
        case 'Flex Day':
            return 'Flex Day';
        case 'Fartlek':
        case 'Intervals':
        case 'Tempo':
            return `${type} - ${volume} ${units}`;
        default:
            return type;
    }
};

const getOptions = (workout, day) => {
    if (day === 0) {
        return {
            'runs/wk': workout.Prescribed['Runs Per Week'],
            'miles/wk': workout.Prescribed['Miles Per Week'],
            'recommended pace': workout.Prescribed.Pace,
        };
    }
    const noOptions = ['Day Off', 'Flex Day', 'Fartlek', 'Intervals', 'Tempo'];
    if (noOptions.indexOf(workout.Prescribed.Type) !== -1) {
        return null;
    }
    const options = {};
    const volume = workout.Prescribed.Volume;
    const units = workout.Prescribed.Units;
    if (volume && units) {
        options[units] = volume;
    }
    const time = workout.Prescribed.Time;
    let timeUnits = 'time';
    if (workout.Prescribed.Time_units) {
        if (workout.Prescribed.Type === 'Race') {
            timeUnits = 'estimated finish';
        } else {
            timeUnits = `total ${workout.Prescribed.Time_units}`;
        }
    }
    if (time && time.trim('') !== '-') {
        options[timeUnits] = time;
    }

    const pace = workout.Prescribed.Pace;
    if (pace) {
        if (workout.Prescribed.RunWalk === 'Yes') {
            options['pace (run-walk)'] = pace;
        } else {
            options.pace = pace;
        }
    }

    return options;
};

const getInstructions = (workout) => {
    const haveInstructions = ['Fartlek', 'Intervals', 'Tempo'];
    if (workout.Prescribed.Type === 'Flex Day') {
        const {
            Volume,
            Time_units: TimeUnits,
            Units,
            Time,
            Pace,
            Pace_units: PaceUnits,
        } = workout.Prescribed;

        const volumeSection = Volume && Units ? `${Volume} ${Units}, cross-train, or day off | `
        : 'Cross-train or Day Off';

        const timeSection = Time && TimeUnits ? `Target: ${Time} ${TimeUnits}` : '';
        const paceSection = Pace && PaceUnits ? `(${Pace} ${PaceUnits})` : '';

        return `${volumeSection} ${timeSection} ${paceSection}`;
    }
    if (haveInstructions.indexOf(workout.Prescribed.Type) !== -1) {
        return workout.Prescribed.Pace;
    }
    return null;
};

export const readLog = (log) => {
    if (!log.Log_ID) {
        return {};
    }
    const time = log.Time ? log.Time.split(':').reverse() : [];
    const comments = log.Comments ? (log.Comments).replace(/<br>/g, '\n') : '';

    return {
        log_id: log.Log_ID,
        log_runtype: log.Type,
        log_comments: comments,
        log_rpe: log.RPE,
        log_miles: log.Volume,
        log_hr: time[2],
        log_min: time[1],
        log_sec: time[0],
        race_name: '',
        log_wuwd_miles: log.Inplan_wuwd,
        log_updaterace: log.log_updaterace,
    };
};

export const readTip = (tip) => {
    if (!tip) {
        return {};
    }
    return {
        body: tip.Text,
        source: tip.Source,
        picture: decodeURIComponent(tip.Avatar),
        type: tip['Media Source'],
        url: tip['Media Source URL'],
    };
};

export const transformWorkout = ({ workout, raceDate, totalWorkouts, goalRaceName, day }) => ({
    title: getTitle(workout.Prescribed.Type, workout.Prescribed.Volume, workout.Prescribed.Units),
    options: Number(day) === totalWorkouts ? {} : getOptions(workout, day),
    instructions: getInstructions(workout),
    completed: !!(workout.Completed && workout.Completed.Log_ID),
    strides: !!get(workout, 'Completed.Strides', 0),
    resistanceTraining: !!get(workout, 'Completed.RT', 0),
    description: workout.Prescribed.Description,
    type: workout.Prescribed.Type,
    headerText: get(workout, 'Prescribed.Header Text', 'Maintain Your Current Running Schedule'),
    day,
    tip: readTip(workout['Training Day Tip']),
    date: workoutDate({
        day,
        raceDate,
        totalWorkouts,
    }),
    week: {
        completed: workout['Weekly Data']['Completed Week'],
        prescribedHigh: workout['Weekly Data']['Prescribed Week High'],
        prescribedLow: workout['Weekly Data']['Prescribed Week Low'],
        overview: workout['Weekly Data'].Overview,
        overviewAvatar: workout['Weekly Data']['Overview Avatar'],
    },
    analytics: get(workout, 'Completed.Workout Analytics', null),
    log: readLog(workout.Completed),
    volume: workout.Prescribed.Volume || 0,
    raceName: day === totalWorkouts ?
        goalRaceName : workout.Prescribed.Inplan_racename,
    strava: mapStrava(workout.Strava, workout.Prescribed.Units),
    goal: Number(day) === totalWorkouts,
    trainingAlertIcon: get(workout, 'RUNtrix Alerts.Other_iconURL', null),
    refresh: +workout.refresh,
    archived: +workout.archived,
    feedbacks: ['Injury', 'Motivational', 'Other']
        .filter(alert => !!get(workout, `RUNtrix Alerts.${alert}`, false))
        .map(alert => ({
            title: alert,
            description: workout['RUNtrix Alerts'][alert],
            icon: workout['RUNtrix Alerts'][`${alert}_iconURL`],
        })),
    wuwdVolume: workout.Prescribed.Inplan_wuwd,
});

const mapStrava = ({
    Distance,
    Strava_LogID,
    Time,
    Name,
    Elevation,
    Strava_Notes: stravaNotes,
    Split_Text: splitText,
}, units) => {
    const sNotes = stravaNotes ?
        `${stravaNotes}` : '';
    const text = splitText ?
        splitText.replace(/<br>/g, '\n') : '';
    const unitsAbbr = units === 'km' ? 'm' : 'ft';

    let notes = '';
    if (Name) {
        notes = `Name: ${Name} | `;
    }
    notes = `${notes} Elevation Gain: ${(Elevation || 0)} ${unitsAbbr}`;
    if (stravaNotes) {
        notes = dedent`
            ${notes}
            Strava Notes:
            ${sNotes}
        `;
    }
    if (splitText) {
        notes = `${notes}\n${text}`;
    }
    return {
        distance: Distance,
        id: Strava_LogID,
        time: Time,
        notes,
    };
};

const transformFullWorkouts = ({
    raceDate,
    totalWorkouts,
    goalRaceName,
    result: { Prescribed, Completed },
}) => {
    const workouts = {};
    Object.keys(Prescribed).forEach((day) => {
        const type = Prescribed[day][0];
        const volume = Prescribed[day][1];
        const completedType = get(Completed, `${day}.0`, null);
        const completedVolume = get(Completed, `${day}.1`, null);
        workouts[day] = {
            title: getTitle(type, volume, ''),
            volume,
            type,
            day,
            date: workoutDate({
                day,
                raceDate,
                totalWorkouts,
            }),
            completed: !!completedType,
            log: {
                log_runtype: completedType,
                log_miles: completedVolume ? completedVolume.replace(/(\s)?m(.*)$/, '') : 0,
            },
            week: {
                completed: 0,
                prescribedHigh: 0,
                prescribedLow: 0,
                overview: 0,
            },
            raceName: Number(day) === totalWorkouts ? goalRaceName : '',
            goal: Number(day) === totalWorkouts,
        };
    });
    return workouts;
};

export const clearAllWorkouts = () => ({
    type: CLEAR_ALL_WORKOUTS,
});



/** WEBPACK FOOTER **
 ** ./src/redux/workouts.js
 **/